export default function getLocaleDate(stringDate: string) {
  const date = new Date(stringDate);

  return date.toLocaleDateString();
}
